/* eslint-disable import/no-mutable-exports */

import { getUrlQuery } from './urlParamsUtils';

interface CustomerData {
  [key: string]: any;
}

export let customerData: CustomerData = {};
export const initCustomerData = () => {
  const getCid = getUrlQuery('cid');
  const getDid = getUrlQuery('did');
  customerData = { ...customerData, decisionId: getDid, cif: getCid };
};

export default customerData;
